module.exports = __webpack_public_path__ + "static/img/bg.b0425e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sfy/bg.jpg
// module id = 7ej8
// module chunks = 2